import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { BsArrowLeftShort } from 'react-icons/bs';

import { EButton, EPinInput } from 'libs/ui';
import { showToast } from 'utils/utility';

interface IProps {
    setActiveStep: Dispatch<SetStateAction<number>>;
    otp: string | null;
    setOTP: Dispatch<SetStateAction<string | null>>;
    isManagingOTP: boolean;
    isLoggingIn: boolean;
    handleCancelOTPVerification: () => void;
    verifyOTP: () => Promise<void>;
};

export default function ValidateOTP({ ...props }: IProps) {

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        // Read a specific query parameter
        const verify = params.get("verify");

        if (verify !== "otp") {
            showToast({
                type: "warning",
                message: "Invalid OTP verification link"
            });
        };
    }, []);


    return (
        <div className="flex flex-col gap-3 border-t-0 mt-5">
            <div>
                <h3 className="flex items-center">
                    <BsArrowLeftShort
                        className="cursor-pointer"
                        onClick={() => {
                            props.handleCancelOTPVerification();
                            props.setOTP(null);
                        }}
                    /> Verify OTP
                </h3>
                <p className="text-sm opacity-50">Please enter the OTP sent to your registered email address</p>
            </div>

            <EPinInput
                size="lg"
                radius="md"
                length={6}
                // error
                type="number"
                placeholder="-"
                value={props.otp ?? undefined}
                onChange={(value) => props.setOTP(value ?? null)}
            />

            <EButton
                fullWidth
                size="md"
                type="submit"
                className="btn-blue mt-5"
                loading={props.isManagingOTP || props.isLoggingIn}
                disabled={props.otp?.length !== 6}
                onClick={props.verifyOTP}
            >Verify</EButton>

            {/* <p className="text-center mt-5 text-sm">
                Didn't receive the code? {" "}
                <span
                    className="text-blue-600 hover:underline hover:cursor-pointer"
                // onClick={openOnboardAgentModal}
                >Resend OTP</span>
            </p> */}
        </div>
    )
}
